module.exports = __webpack_public_path__ + "img/figures-1.1.cb7974c3.png";